import React from 'react'
import PropTypes from 'prop-types'

import Button from '../../components/display/Button'

class AddToBucketList extends React.Component {
  render() {
    const { isActive, onClick, fetching, ...props } = this.props

    return (
      <Button
        onClick={onClick}
        disabled={fetching}
        ghost
        aria-label={isActive ? 'Remove from bucket list' : 'Add to bucket list'}
        uppercase={false}
        {...props}
      >
        {fetching && (
          <div className="lds-ring">
            <div />
            <div />
            <div />
            <div />
          </div>
        )}
        {!fetching && (
          <span
            className={`icon icon-bucketlist-heart-${isActive ? 'on' : 'off'}`}
          />
        )}
        Bucket List
      </Button>
    )
  }
}

AddToBucketList.propTypes = {
  isActive: PropTypes.bool.isRequired,
}

export default AddToBucketList
